export const devolution = {
	expired: "Expired",
	title: "Expired recharges",
	toExpire: "To expire",
	totalExpired: "Total expired recharges",
	totalToExpire: "Total recharges to expire",
};
